import { useEffect, useState } from "react";

import {
  Dialog,
  DialogTitle,
  DialogBody,
  DialogActions,
} from "V2.0/common/dialog";
import { Button } from "V2.0/common/button";
import { Textarea } from "V2.0/common/textarea";
import { Input } from "V2.0/common/input";
import { ErrorMessage, Field, Label } from "V2.0/common/fieldset";

import { PlusIcon } from "@heroicons/react/24/outline";

import { message } from "antd";
import { showErrorToast } from "V2.0/utils";

export default PipelineCreate;

function PipelineCreate(props) {
  const { onPipelineCreate } = props;

  const [pipelineName, setPipelineName] = useState("");
  const [pipelineDescription, setPipelineDescription] = useState("");

  const [open, setOpen] = useState(false);
  const [errors, setErrors] = useState(undefined);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    return () => {
      setPipelineName("");
      setPipelineDescription("");
      setErrors("");
    };
  }, [open]);

  const handleChangePipelineName = (event) => {
    setErrors(null);
    const name = event.target.value;
    setPipelineName(name);
  };

  const handleChangePipelineDescription = (event) => {
    const description = event.target.value;
    setPipelineDescription(description);
  };

  const handlePipelineCreate = async () => {
    const lifecycleCbs = {
      init() {
        setLoading(true);
        message.loading("Creating Pipeline");
      },
      success() {
        setLoading(false);
        message.destroy();
        message.success("Pipeline created");
        setOpen(false);
      },
      error(e) {
        setLoading(false);
        message.destroy();
        showErrorToast(e, "Failed to create pipeline");
      },
    };

    const payload = {
      name: pipelineName,
      description: pipelineDescription,
      nodes: [],
      edges: [],
    };

    onPipelineCreate(payload, lifecycleCbs);
  };

  const isNameEmpty = pipelineName === "";
  const isCreateDisabled = isNameEmpty || errors?.message || loading;

  return (
    <>
      <Button onClick={() => setOpen(true)}>
        <PlusIcon /> Create Pipeline V2
      </Button>
      <Dialog
        open={open}
        onClose={() => {}}
      >
        <DialogTitle>Create Pipeline V2</DialogTitle>
        <DialogBody>
          <div className="flex flex-col gap-y-4">
            <Field>
              <Label>Pipeline Name *</Label>
              <Input
                type="text"
                value={pipelineName}
                onChange={handleChangePipelineName}
              />
              {errors?.message && <ErrorMessage>{errors.message}</ErrorMessage>}
            </Field>
            <Field>
              <Label>Description </Label>
              <Textarea
                value={pipelineDescription}
                onChange={handleChangePipelineDescription}
              />
            </Field>
          </div>
        </DialogBody>
        <DialogActions>
          <Button
            outline
            onClick={() => setOpen(false)}
          >
            Cancel
          </Button>
          <Button
            onClick={handlePipelineCreate}
            disabled={isCreateDisabled}
            loading={loading}
          >
            Create
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
